import { useEffect, useRef } from 'react';

export const useSplitTableScroll = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const body = bodyRef.current;
    const header = headerRef.current;
    if (!body || !header) {
      return;
    }

    const syncScroll = () => {
      header.scrollLeft = body.scrollLeft;
    };

    // Narrow the header by the width the body's scrollbar reserves, so the columns line up.
    const syncScrollbarGutter = () => {
      header.style.marginRight = `${body.offsetWidth - body.clientWidth}px`;
    };

    syncScroll();
    syncScrollbarGutter();

    body.addEventListener('scroll', syncScroll, { passive: true });

    const observer = new ResizeObserver(syncScrollbarGutter);
    observer.observe(body);
    const table = body.firstElementChild;
    if (table) {
      observer.observe(table);
    }

    return () => {
      body.removeEventListener('scroll', syncScroll);
      observer.disconnect();
    };
  }, []);

  return { headerRef, bodyRef };
};
